export default __webpack_public_path__ + "static/media/logo-app2b.33d4284d.svg";